import type { FC } from 'react';

interface CardItem {
  tag: string;
  title: string;
  desc: string;
  imageUrl: string;
  alt: string;
}

const cardsData: CardItem[] = [
  {
    tag: '最新',
    title: '某顶流男星夜会神秘女子',
    desc: '独家拍到某顶流男星深夜与神秘女子同返公寓，全程高清画面记录，黑料视频第一时间发布完整内容。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20night%20paparazzi%20style%20photograph%20of%20luxury%20apartment%20building%20entrance%20with%20warm%20streetlight%20glow%2C%20mysterious%20silhouettes%2C%20dark%20urban%20night%20atmosphere%2C%20cinematic%20composition%20with%20crimson%20and%20amber%20tones%2C%20editorial%20photography%20quality&width=600&height=400&seq=cards-01&orientation=landscape',
    alt: '某顶流男星夜会神秘女子 - 黑料视频独家爆料',
  },
  {
    tag: '热议',
    title: '网红带货翻车现场全记录',
    desc: '知名带货主播直播翻车完整视频曝光，黑料视频独家获取未剪辑版，引发全网热议持续发酵。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20live%20streaming%20studio%20scene%20with%20professional%20lighting%20equipment%20and%20monitors%2C%20warm%20studio%20lighting%20with%20dramatic%20shadows%2C%20luxurious%20dark%20backdrop%2C%20cinematic%20wide%20shot%20composition%2C%20editorial%20quality%20with%20rich%20crimson%20accents&width=600&height=400&seq=cards-02&orientation=landscape',
    alt: '网红带货翻车现场全记录 - 黑料视频热议内容',
  },
  {
    tag: '追踪',
    title: '知名企业家资金链断裂内幕',
    desc: '深度调查某知名企业家资金链断裂全过程，多方消息交叉验证，黑料视频为你呈现最完整真相。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20corporate%20boardroom%20scene%20with%20empty%20chairs%20and%20scattered%20documents%2C%20warm%20overhead%20lighting%20creating%20harsh%20shadows%2C%20dark%20premium%20atmosphere%2C%20cinematic%20composition%20with%20rich%20crimson%20and%20amber%20tone%2C%20editorial%20photography%20quality&width=600&height=400&seq=cards-03&orientation=landscape',
    alt: '知名企业家资金链断裂内幕 - 黑料视频深度追踪',
  },
  {
    tag: '独家',
    title: '选秀节目黑幕录音流出',
    desc: '某大型选秀节目内部录音完整版本流出，揭露投票操纵与选手内定真相，黑料视频独家首发。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20talent%20show%20stage%20with%20spotlights%20and%20empty%20audience%20seats%2C%20theatrical%20lighting%20with%20deep%20shadows%2C%20dark%20moody%20atmosphere%20with%20crimson%20curtains%2C%20cinematic%20composition%2C%20editorial%20photography%20quality%20with%20warm%20tone&width=600&height=400&seq=cards-04&orientation=landscape',
    alt: '选秀节目黑幕录音流出 - 黑料视频独家首发',
  },
  {
    tag: '热点',
    title: '豪宅派对不雅视频外泄',
    desc: '某富商私人豪宅派对现场视频遭外泄，画面内容引发伦理争议，黑料视频持续跟进事件进展。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxurious%20mansion%20party%20aftermath%20scene%20with%20dim%20ambient%20lighting%2C%20empty%20champagne%20glasses%20and%20scattered%20decorations%2C%20dramatic%20shadows%2C%20dark%20atmospheric%20interior%20with%20golden%20accents%2C%20cinematic%20composition%2C%20editorial%20photography%20quality&width=600&height=400&seq=cards-05&orientation=landscape',
    alt: '豪宅派对不雅视频外泄 - 黑料视频热点追踪',
  },
  {
    tag: '内幕',
    title: '影视剧组潜规则大起底',
    desc: '多位业内人士匿名爆料影视剧组选角潜规则内幕，黑料视频整理完整证据链逐条呈现。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20film%20set%20scene%20with%20professional%20camera%20equipment%20and%20empty%20directors%20chair%2C%20warm%20set%20lighting%20with%20long%20shadows%2C%20dark%20atmospheric%20backstage%20area%2C%20cinematic%20composition%2C%20editorial%20photography%20quality%20with%20crimson%20tone&width=600&height=400&seq=cards-06&orientation=landscape',
    alt: '影视剧组潜规则大起底 - 黑料视频内幕深扒',
  },
  {
    tag: '爆料',
    title: '高管出差酒店密会情人',
    desc: '某知名企业高管出差期间酒店密会情人被拍，画面清晰过程完整，黑料视频为你还原事件全貌。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20luxury%20hotel%20corridor%20at%20night%20with%20warm%20ambient%20lighting%2C%20soft%20carpet%20and%20elegant%20wall%20sconces%2C%20dramatic%20shadows%20and%20atmospheric%20light%2C%20dark%20premium%20interior%2C%20cinematic%20composition%2C%20editorial%20photography%20quality%20with%20crimson%20accents&width=600&height=400&seq=cards-07&orientation=landscape',
    alt: '高管出差酒店密会情人 - 黑料视频爆料内容',
  },
];

interface MediaItem {
  tag: string;
  title: string;
  views: string;
  duration: string;
  imageUrl: string;
  alt: string;
}

const mediaData: MediaItem[] = [
  {
    tag: '明星',
    title: '当红小花与前经纪人对峙录像',
    views: '89.2万',
    duration: '12:36',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20confrontation%20scene%20with%20two%20people%20facing%20each%20other%20in%20a%20luxury%20office%2C%20warm%20dramatic%20lighting%20with%20deep%20shadows%2C%20dark%20premium%20atmosphere%2C%20cinematic%20composition%2C%20editorial%20photography%20quality%20with%20crimson%20and%20amber%20tones&width=600&height=340&seq=media-01&orientation=landscape',
    alt: '当红小花与前经纪人对峙录像 - 黑料视频媒体内容',
  },
  {
    tag: '内幕',
    title: '知名品牌代工厂黑幕暗访视频',
    views: '67.8万',
    duration: '25:18',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clandestine%20investigative%20scene%20inside%20a%20dim%20factory%20space%20with%20dramatic%20industrial%20lighting%2C%20warm%20overhead%20lights%20creating%20atmospheric%20shadows%2C%20dark%20moody%20atmosphere%2C%20cinematic%20documentary%20composition%2C%20editorial%20photography%20quality&width=600&height=340&seq=media-02&orientation=landscape',
    alt: '知名品牌代工厂黑幕暗访视频 - 黑料视频内幕内容',
  },
  {
    tag: '爆料',
    title: '富二代聚众事件完整流出视频',
    views: '153.4万',
    duration: '18:52',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20nightclub%20scene%20with%20atmospheric%20neon%20lighting%20and%20crowd%20silhouettes%2C%20warm%20ambient%20light%20with%20deep%20shadows%2C%20dark%20luxurious%20atmosphere%2C%20cinematic%20wide%20shot%20composition%2C%20editorial%20photography%20quality%20with%20crimson%20tone&width=600&height=340&seq=media-03&orientation=landscape',
    alt: '富二代聚众事件完整流出视频 - 黑料视频爆料内容',
  },
  {
    tag: '追踪',
    title: '某平台主播合同纠纷全程记录',
    views: '42.6万',
    duration: '32:15',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20streaming%20studio%20with%20multiple%20monitors%20and%20equipment%20in%20dim%20lighting%2C%20warm%20ambient%20glow%20from%20screens%2C%20dark%20atmospheric%20room%2C%20cinematic%20composition%2C%20editorial%20photography%20quality%20with%20crimson%20accents&width=600&height=340&seq=media-04&orientation=landscape',
    alt: '某平台主播合同纠纷全程记录 - 黑料视频追踪内容',
  },
];

interface CommentItem {
  name: string;
  time: string;
  content: string;
  likes: string;
}

const commentsData: CommentItem[] = [
  {
    name: '吃瓜群众老王',
    time: '2小时前',
    content: '黑料视频的更新速度真的太快了，每次热点事件发生不到一小时就能看到完整视频。内容质量也很高，画面清晰不模糊，比我在其他平台看到的都要完整。国产专区整理得很用心，每天必刷！',
    likes: '328',
  },
  {
    name: '深夜追更人',
    time: '5小时前',
    content: '作为一名老用户，从91黑料视频时期就一直在追，现在黑料视频的体验确实提升了很多。视频播放流畅不卡顿，下载功能也很方便。建议大家可以多看看精品合集区，每条都值得收藏。',
    likes: '256',
  },
  {
    name: '真相追踪者',
    time: '8小时前',
    content: '对比过好几个类似平台，黑料视频的内容时效性和全面性确实是最好的。特别欣赏平台对每条视频都进行审核验证的态度，让我看得很放心。希望继续保持这样的更新节奏和水准。',
    likes: '189',
  },
];

const CardsSection: FC = () => (
  <section id="cards" className="relative w-full py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          图文资讯
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          最新黑料视频资讯图文速览，第一时间掌握全网爆料动态
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
        {cardsData.slice(0, 7).map((item, idx) => (
          <article
            key={idx}
            className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
              idx === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
            }`}
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                {item.tag}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const ContactSection: FC = () => (
  <section id="contact" className="relative w-full py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            欢迎提供视频线索与独家爆料素材，审核通过后将第一时间在平台发布
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center cursor-pointer hover:border-primary-300 transition-all duration-200">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-mail-line text-2xl"></i>
            </div>
            <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900">投稿邮箱</h3>
            <p className="mt-2 text-sm text-foreground-500">tips@heiliao.com</p>
          </div>
          <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center cursor-pointer hover:border-primary-300 transition-all duration-200">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-wechat-line text-2xl"></i>
            </div>
            <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900">微信联系</h3>
            <p className="mt-2 text-sm text-foreground-500">heiliao_official</p>
          </div>
          <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center cursor-pointer hover:border-primary-300 transition-all duration-200">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-message-2-line text-2xl"></i>
            </div>
            <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900">在线留言</h3>
            <p className="mt-2 text-sm text-foreground-500">24小时内回复</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const MediaSection: FC = () => (
  <section id="media" className="relative w-full py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          热门视频
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          本周播放量最高的黑料视频精选，不可错过的热门内容
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {mediaData.map((item, idx) => (
          <article
            key={idx}
            className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
          >
            <div className="relative aspect-video overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 shadow-lg">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-background-50/90 text-foreground-900 text-xs font-medium">
                {item.tag}
              </span>
              <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                {item.duration}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <div className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-eye-line"></i>
                <span>{item.views} 次播放</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const CommentsSection: FC = () => (
  <section id="comments" className="relative w-full py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
          用户热议
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          黑料视频用户真实评价与讨论，看看大家都在聊什么
        </p>
      </div>
      <div className="max-w-3xl mx-auto grid gap-4">
        {commentsData.map((comment, idx) => (
          <article
            key={idx}
            className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm">
                {comment.name.charAt(0)}
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                <div className="text-xs text-foreground-500">{comment.time}</div>
              </div>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {comment.content}
            </p>
            <div className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-thumb-up-line"></i>
              <span>{comment.likes}</span>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default function SectionsPart2() {
  return (
    <>
      <CardsSection />
      <ContactSection />
      <MediaSection />
      <CommentsSection />
    </>
  );
}